// En-tête fixe du site WordPress qui héberge le widget (Breakdance, ex. 88 px sur mobile).
// Il se masque en défilant vers le bas et revient vers le haut : les éléments collants du widget
// (aperçu du configurateur, étapes du lot) le mesurent en direct pour se placer juste dessous.
import { useEffect, useState } from 'react'

/** Bas de l'en-tête fixe visible en haut de l'écran, en px (0 s'il est masqué ou absent). */
export function siteHeaderHeight(): number {
  if (typeof document === 'undefined') return 0
  let bottom = 0
  for (const el of document.elementsFromPoint(window.innerWidth / 2, 2)) {
    let n: Element | null = el
    while (n && n !== document.body) {
      const pos = getComputedStyle(n).position
      if (pos === 'fixed' || pos === 'sticky') {
        const r = n.getBoundingClientRect()
        if (r.top <= 2 && r.height < window.innerHeight / 3) bottom = Math.max(bottom, r.bottom)
        break
      }
      n = n.parentElement
    }
  }
  return Math.round(bottom)
}

/** Appelle onChange avec la hauteur de l'en-tête à chaque défilement (et une fois son animation terminée). */
export function watchSiteHeader(onChange: (px: number) => void): () => void {
  let raf = 0
  let settle: ReturnType<typeof setTimeout> | undefined
  const measure = () => { raf = 0; onChange(siteHeaderHeight()) }
  const onScroll = () => {
    if (!raf) raf = requestAnimationFrame(measure)
    clearTimeout(settle)
    settle = setTimeout(measure, 600) // l'en-tête glisse en ~500 ms
  }
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  measure()
  return () => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
    cancelAnimationFrame(raf)
    clearTimeout(settle)
  }
}

/** Hauteur de l'en-tête du site, mise à jour au défilement. */
export function useSiteHeaderOffset(): number {
  const [px, setPx] = useState(0)
  useEffect(() => watchSiteHeader(setPx), [])
  return px
}
